import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import PrivacyConsentPopup from '@/components/header/PrivacyConsentPopup';

type PrivacyConsentPopupContextValue = {
	openPrivacyConsentPopup: () => void;
	closePrivacyConsentPopup: () => void;
	isPrivacyConsentPopupOpen: boolean;
};

const PrivacyConsentPopupContext = createContext<PrivacyConsentPopupContextValue | undefined>(undefined);

export function PrivacyConsentPopupProvider({ children }: { children: ReactNode }) {
	const [isPrivacyConsentPopupOpen, setIsPrivacyConsentPopupOpen] = useState(false);

	const value = useMemo(
		() => ({
			openPrivacyConsentPopup: () => setIsPrivacyConsentPopupOpen(true),
			closePrivacyConsentPopup: () => setIsPrivacyConsentPopupOpen(false),
			isPrivacyConsentPopupOpen
		}),
		[isPrivacyConsentPopupOpen]
	);

	return (
		<PrivacyConsentPopupContext.Provider value={value}>
			{children}
			{isPrivacyConsentPopupOpen &&
				createPortal(<PrivacyConsentPopup onClose={value.closePrivacyConsentPopup} />, document.body)}
		</PrivacyConsentPopupContext.Provider>
	);
}

export function usePrivacyConsentPopup() {
	const context = useContext(PrivacyConsentPopupContext);
	if (!context) {
		throw new Error('usePrivacyConsentPopup must be used within PrivacyConsentPopupProvider');
	}
	return context;
}
